import * as React from 'react'

import { Plus } from 'lucide-react'
import { inject, observer } from 'mobx-react'

import { LocationType } from '~/client/graph'
import { Button } from '~/client/src/shared/components/Button/Button'
import MapViewItemBase from '~/client/src/shared/components/SitemapHelpers/models/MapViewItemBase'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import InitialState from '~/client/src/shared/stores/InitialState'

import LocationCardBody from './LocationCardBody'

interface IProps {
  item: MapViewItemBase
  onPlusButtonClick?: () => void
  state?: InitialState
  selectedStartDate?: Date
  selectedEndDate?: Date
}

export function canCreateWorkflowAt(
  item: MapViewItemBase,
  state: InitialState,
): boolean {
  return (
    !item.dataObject.is(LocationType.OffloadingEquipment) &&
    !state.isWorkflowsDisabled
  )
}

@inject('state')
@observer
export default class LocationCard extends React.Component<IProps> {
  public render() {
    const { item, onPlusButtonClick, selectedStartDate, selectedEndDate } =
      this.props

    if (!item?.dataObject) {
      return null
    }

    return (
      <div className="tw:z-[1] tw:flex tw:w-[335px] tw:items-center tw:gap-3 tw:rounded-lg tw:bg-popover tw:p-3 tw:text-popover-foreground tw:shadow-md">
        <LocationCardBody
          item={item}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
        />
        {this.shouldShowPlusButton && (
          <Button
            variant="ghost"
            size="icon"
            title={Localization.translator.createWorkflow}
            aria-label={Localization.translator.createWorkflow}
            onClick={onPlusButtonClick}
          >
            <Plus />
          </Button>
        )}
      </div>
    )
  }

  private get shouldShowPlusButton(): boolean {
    const { item, state, onPlusButtonClick } = this.props
    // Gated on the handler too: the prop is optional, so a wrapper that forgot it used to
    // render a pointer-cursor button that did nothing, with no type error to catch it.
    return !!onPlusButtonClick && canCreateWorkflowAt(item, state)
  }
}
